import React from 'react';
import { Filter, ChevronDown, AlertTriangle } from 'lucide-react';
const PRODUCTS = [{
  id: '4C16D-20-D',
  name: 'Versatile 4C Depot 16H - 20 Door Package',
  sku: '4C16D-20-D',
  price: '$4,353.00',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2Fauthflorence%2FVario+Depots%2F4C16D-20-DDB.jpg&h=300&site=6153&user=4145&v=1&w=300',
  note: 'Confirm requirements before ordering',
  href: '/m8/4C16D-20-D--versatile-4c-depot-16h-20-door-package.html'
}, {
  id: 'CBU-16',
  name: '16-Door Cluster Box Unit (CBU) with Pedestal',
  sku: '1570-16',
  price: '$1,850.00',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2Fauthflorence%2FVario+Depots%2F4C16D-20-DDB.jpg&h=300&site=6153&user=4145&v=1&w=300',
  note: 'USPS Approved',
  href: '#'
}, {
  id: '4C-LOCK',
  name: 'Replacement Tenant Lock for 4C Mailboxes',
  sku: 'K400-T',
  price: '$18.50',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2Fauthflorence%2FVario+Depots%2F4C16D-20-DDB.jpg&h=300&site=6153&user=4145&v=1&w=300',
  note: 'Replacement part',
  href: '#'
}, {
  id: 'PARCEL-2',
  name: 'Outdoor Parcel Locker (OPL) - 2 Door',
  sku: '1590-T2',
  price: '$1,200.00',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2Fauthflorence%2FVario+Depots%2F4C16D-20-DDB.jpg&h=300&site=6153&user=4145&v=1&w=300',
  note: 'Commercial delivery',
  href: '#'
}];
export function ProductList() {
  return <div id="products" className="py-12 bg-white" data-id="element-73">
      <div className="max-w-7xl mx-auto px-4 flex flex-col lg:flex-row gap-8" data-id="element-74">
        {/* Sidebar Filters (Mockup) */}
        <aside className="w-full lg:w-64 shrink-0" data-id="element-75">
          <div className="flex items-center justify-between mb-6 lg:hidden" data-id="element-76">
            <h3 className="font-bold text-lg" data-id="element-77">Filters</h3>
            <button className="flex items-center gap-2 text-brand-green border border-brand-border px-3 py-1.5 rounded" data-id="element-78">
              <Filter size={16} data-id="element-79" /> Filter
            </button>
          </div>

          <div className="hidden lg:block space-y-6" data-id="element-80">
            <h3 className="font-bold text-lg border-b border-brand-border pb-2" data-id="element-81">
              Filter Products
            </h3>

            {['Product Type', 'Door Count', 'Parcel Locker Needs', 'Indoor/Outdoor', 'Mounting/Install Type', 'Brand', 'Finish', 'Price', 'Availability'].map(filter => <div key={filter} className="border-b border-brand-border/50 pb-4" data-id="element-82">
                <button className="flex items-center justify-between w-full font-medium text-brand-charcoal hover:text-brand-green" data-id="element-83">
                  {filter}
                  <ChevronDown size={16} className="text-gray-400" data-id="element-84" />
                </button>
              </div>)}
          </div>
        </aside>

        {/* Main Content */}
        <div className="flex-1" data-id="element-85">
          {/* Controls Bar */}
          <div className="flex flex-col sm:flex-row justify-between items-center bg-brand-cream p-4 rounded-lg border border-brand-border mb-6 gap-4" data-id="element-86">
            <span className="text-sm text-gray-600 font-medium" data-id="element-87">
              Showing 42 products
            </span>
            <div className="flex items-center gap-3 w-full sm:w-auto" data-id="element-88">
              <label htmlFor="sort" className="text-sm font-medium text-gray-700 whitespace-nowrap" data-id="element-89">
                Sort by:
              </label>
              <select id="sort" className="w-full sm:w-auto bg-white border border-brand-border rounded-md py-1.5 pl-3 pr-8 text-sm focus:ring-brand-green focus:border-brand-green" data-id="element-90">
                <option data-id="element-91">Featured</option>
                <option data-id="element-92">Price Low-High</option>
                <option data-id="element-93">Price High-Low</option>
                <option data-id="element-94">Newest</option>
              </select>
            </div>
          </div>

          {/* Product Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6" data-id="element-95">
            {PRODUCTS.map(product => <div key={product.id} className="group bg-white rounded-xl border border-brand-border overflow-hidden hover:shadow-md hover:border-brand-green/50 transition-all flex flex-col" data-id="element-96">
                <a href={product.href} className="block relative bg-brand-cream/30 aspect-square p-6 border-b border-brand-border/50" data-id="element-97">
                  <img src={product.image} alt={product.name} className="w-full h-full object-contain mix-blend-multiply group-hover:scale-105 transition-transform duration-500" data-id="element-98" />

                  {product.note && <div className="absolute top-3 left-3 right-3" data-id="element-99">
                      <span className="inline-flex items-center gap-1.5 bg-white/90 backdrop-blur text-xs font-semibold px-2.5 py-1 rounded border border-brand-border shadow-sm text-brand-charcoal" data-id="element-100">
                        {product.note.includes('Confirm') && <AlertTriangle size={12} className="text-brand-gold" data-id="element-101" />}
                        {product.note}
                      </span>
                    </div>}
                </a>

                <div className="p-5 flex flex-col flex-grow" data-id="element-102">
                  <div className="text-xs text-gray-500 mb-1 font-mono" data-id="element-103">
                    {product.sku}
                  </div>
                  <a href={product.href} className="font-bold text-brand-charcoal hover:text-brand-green transition-colors mb-2 line-clamp-2 leading-snug" data-id="element-104">
                    {product.name}
                  </a>
                  <div className="text-lg font-bold text-brand-green mb-6 mt-auto" data-id="element-105">
                    {product.price}
                  </div>

                  <div className="space-y-2" data-id="element-106">
                    <a href={product.href} className="block w-full bg-brand-charcoal hover:bg-brand-green text-white text-center py-2.5 rounded-md font-semibold transition-colors text-sm" data-id="element-107">
                      View details
                    </a>
                    <a href="/ContactUs.html" className="block w-full bg-white border border-brand-border hover:border-brand-green text-brand-charcoal text-center py-2.5 rounded-md font-medium transition-colors text-sm" data-id="element-108">
                      Ask before ordering
                    </a>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
}